import { Clause15Home } from '../../pages/clause15';

export const clause15 = [
  {
    path: 'clause15',
    element: <Clause15Home />,
  },
];
